export const projectName = 'sigma'

export const states = {
  empty: 'empty',
  ready: 'ready',
  loading: 'loading',
  error: 'error',
  success: 'success'
}

export const macroCacheOptions = {
  ttl: 1000,
  ttlInterval: 1000,
  renewOnGet: false
}
